/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_New_Rooster_FlipInputs */

const fr_agent_new_rooster_flip = /** @type {(inputs: Agent_New_Rooster_FlipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

/**

* @param {Agent_New_Rooster_FlipInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const agent_new_rooster_flip = /** @type {((inputs?: Agent_New_Rooster_FlipInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_New_Rooster_FlipInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_agent_new_rooster_flip(inputs)
});